// ─── 路由路径 ─────────────────────────────────────────────────────────────────

export const ROUTE_LOGIN = '/login';
export const ROUTE_LOGIN_SUCCESS = '/login-success';
export const ROUTE_TELE_MONITORING = '/tele-monitoring';

/** 不需要登录鉴权的公开页面路径列表 */
export const PUBLIC_ROUTES: string[] = [ROUTE_LOGIN, ROUTE_LOGIN_SUCCESS];
